export default {"src":"/_next/static/media/doctor.a52fefba.svg","height":178,"width":128};